$('[data-bs-toggle="tooltip"]').tooltip();

//sweetalert
var btn = $("#back-to-top");
btn.click(function () {
    $("html, body").animate({ scrollTop: 0 }, "fast");
});

//play video
if ($(".nd-js-btn-play-video").length) {
    var v = document.getElementById("video-sobre");
    $("body").on("click", ".nd-js-btn-play-video", function () {
        //v.play();
        if (v.paused) {
            v.play();
            //v.controls=true;
            $(this).css("opacity", 0);
        } else {
            v.pause();
            //v.controls="";
            $(this).css("opacity", 1);
        }
    });
}

Fancybox.bind("[data-fancybox]", {
    mainStyle: {
        zoom: "200%",
        background: "#242427",
    },
});

const btnFullscreen = document.getElementById("btnFullscreen");

btnFullscreen.addEventListener("click", (event) => {
    event.preventDefault;
    if (!document.fullscreenElement) {
        // Entra em tela cheia
        document.documentElement.requestFullscreen().catch((err) => {
            console.error(`Erro ao ativar tela cheia: ${err.message}`);
        });
        btn.textContent = "Sair da Tela Cheia";
    } else {
        // Sai do modo tela cheia
        document.exitFullscreen();
        btn.textContent = "Tela Cheia";
    }
});

// Atualiza texto se sair da tela cheia com ESC ou outro comando
document.addEventListener("fullscreenchange", () => {
    if (!document.fullscreenElement) {
        btn.textContent = "Tela Cheia";
    }
});

let currentVideo = null; // guarda o vídeo em fullscreen

async function playFullscreen(videoId) {
    const video = document.getElementById(videoId);
    if (!video) return;

    currentVideo = video;
    video.style.display = "block";

    try {
        await video.requestFullscreen();
        await video.play();
    } catch (err) {
        console.error("Erro ao abrir vídeo em fullscreen:", err.message);
    }

    // Fecha fullscreen automaticamente quando o vídeo termina
    video.onended = async () => {
        try {
            if (document.fullscreenElement) {
                await document.exitFullscreen();
            }
        } catch (err) {
            console.warn("Erro ao sair do fullscreen:", err.message);
        }
    };
}

// Esconde o vídeo quando sai do fullscreen (ESC, F11 ou fim do vídeo)
document.addEventListener("fullscreenchange", () => {
    if (!document.fullscreenElement && currentVideo) {
        currentVideo.pause();
        currentVideo.style.display = "none";
        currentVideo = null;
    }
});

// Liga os links aos vídeos
document.querySelectorAll(".video-link").forEach((link) => {
    link.addEventListener("click", (e) => {
        e.preventDefault();
        const videoId = link.getAttribute("data-video");
        playFullscreen(videoId);
    });
});

// Traduções

function initTranslations() {
    const lang = new URLSearchParams(window.location.search).get('lang') || 'pt';
    const data = translations[lang] || translations.pt;

    document.documentElement.lang = lang;
    document.title = data.pageTitle;

    document.querySelectorAll('[data-i18n]').forEach(function (element) {
        const keys = element.dataset.i18n.split('.');
        let value = data;

        keys.forEach(function (key) {
            value = value?.[key];
        });

        if (!value) return;

        if (element.tagName === 'IMG') {
            element.src = value;
        } else {
            element.innerHTML = value;
        }
    });

    document.querySelectorAll('a[href]').forEach(function (link) {
    const href = link.getAttribute('href');

        if (href.includes('lang=pt') || href.includes('lang=es') || href.includes('lang=en')) return;

        const url = new URL(href, window.location.href);
        url.searchParams.set('lang', lang);
        link.href = url.pathname + url.search + url.hash;
    });

    const suffix = lang === 'en' ? '-us' : lang === 'es' ? '-es' : '';

    document.querySelectorAll('.video-link').forEach(function (link) {
        const video = document.getElementById(link.dataset.video);
        const button = link.querySelector('img');

        video.src = 'media/video/' + link.dataset.video + suffix + '.mp4';
        button.src = 'media/img/assets/btn-video-' + (lang === 'en' ? 'us' : lang === 'es' ? 'es' : 'br') + '.svg';
    });

}

document.addEventListener('DOMContentLoaded', function () {
    initTranslations();
});
//  const lang = new URLSearchParams(window.location.search).get('lang') || 'pt';
//     const data = translations[lang] || translations.pt;

//     document.documentElement.lang = lang;
//     document.title = data.pageTitle;

//     document.querySelectorAll('[data-i18n]').forEach(function (element) {
//         const keys = element.dataset.i18n.split('.');
//         let value = data;

//         keys.forEach(function (key) {
//             value = value[key];
//         });

//         if (value) element.textContent = value;
//     });

    
    
